// src/App.js — FIXED: no infinite loading, all routes work
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import { ToastProvider } from './components/Toast'
import { LangProvider } from './lib/i18n'
import './styles/global.css'

import LandingPage        from './pages/LandingPage'
import LoginPage          from './pages/LoginPage'
import SignupPage         from './pages/SignupPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage  from './pages/ResetPasswordPage'
import DashboardPage      from './pages/DashboardPage'
import AdminPage          from './pages/AdminPage'
import NotFoundPage       from './pages/NotFoundPage'

function PageLoader() {
  return (
    <div style={{
      position:'fixed', inset:0, background:'#080706',
      display:'flex', flexDirection:'column',
      alignItems:'center', justifyContent:'center', gap:20, zIndex:9999
    }}>
      <div style={{fontFamily:'Cormorant Garamond,serif',fontSize:32,color:'#C9A84C',letterSpacing:6,fontWeight:300}}>
        Sky <span style={{color:'#F2E8D8'}}>Bri</span>
      </div>
      <div style={{width:24,height:24,borderRadius:'50%',border:'1.5px solid rgba(201,168,76,0.2)',borderTopColor:'#C9A84C',animation:'spin 0.9s linear infinite'}}/>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}*{box-sizing:border-box}`}</style>
    </div>
  )
}

function ProtectedRoute({ children }) {
  const { session, loading } = useAuth()
  if (loading) return <PageLoader />
  if (!session) return <Navigate to="/login" replace />
  return <>{children}</>
}

function PublicOnlyRoute({ children }) {
  const { session, loading } = useAuth()
  // KEY FIX: public pages render immediately while loading
  // Only redirect if we know there's a session
  if (loading) return <>{children}</>
  if (session) return <Navigate to="/dashboard" replace />
  return <>{children}</>
}

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <ToastProvider>
          <BrowserRouter>
            <Routes>
              {/* Public — always accessible */}
              <Route path="/"                element={<LandingPage />} />
              <Route path="/login"           element={<PublicOnlyRoute><LoginPage /></PublicOnlyRoute>} />
              <Route path="/join"            element={<PublicOnlyRoute><SignupPage /></PublicOnlyRoute>} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password"  element={<ResetPasswordPage />} />

              {/* Protected */}
              <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
              <Route path="/admin"     element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />

              {/* Catch all */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </AuthProvider>
    </LangProvider>
  )
}
